import {ApisauceInstance} from 'apisauce';

// Url
import {url} from '../api.url';

// Type
type FormDataProps = {
	[index: string]: string | number | boolean
};

const addressApi = (api: ApisauceInstance) => {
	const getAllAddresses = () => api.get(url.addresses);
	const deleteAddressesById = (id: number) => api.delete(`${url.addresses}/${id}`);
	const sendAddresses = (formData: FormDataProps) => api.post(url.addresses, formData || {});
	const updateAddresses = (formData: FormDataProps, id: number) => api.put(`${url.addresses}/${id}`, formData || {});

	const usaStates = () => api.get(url.usaStates);
	const addressesCountries = () => api.get(url.addressesCountries);

	return {
		sendAddresses,
		getAllAddresses,
		updateAddresses,
		deleteAddressesById,

		usaStates,
		addressesCountries,
	};
};

export default addressApi;
